import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {Conf} from "../settings/config";
import * as $ from "jquery/dist/jquery.min.js";
import {ShareButtons} from "@ngx-share/core";

@Component({
    selector: 'app-be-inspired',
    templateUrl: './be-inspired.component.html'
})

export class BeInspiredComponent implements OnInit {

    public slug;

    blog = {
        "title": null,
        "slug": null,
        "content": null,
        "author": null,
        "thumbnail_image": null
    };

    galleryOptions = [
        {
            width: '600px',
            height: '400px',
            thumbnailsColumns: 4,
        }
    ];
    categories = [];

    author = {};

    galleryImages = [];
    blog_images = [];

    constructor(public share: ShareButtons, private route: ActivatedRoute, private router: Router, private http: HttpClient, public _auth: AuthService) {

    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.slug = params['slug'];
            this.getBlog();
        });
    }

    getBlog() {
        this.http.get(Conf.API_URL + '/blog/?slug=' + this.slug).subscribe(
            data => {
                if (data['results'].length) {
                    this.blog = data['results'][0];
                    this.getAuthor();
                } else {
                    this.router.navigateByUrl('/404');
                    return false;
                }
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getAuthor() {
        if (this.blog.author) {
            this.http.get(Conf.API_URL + '/author/' + this.blog.author + '/').subscribe(
                data => {
                    this.author = data;
                },
                error => {
                    console.log(error.error)
                }
            );
        }
    }


    getBlogImages() {
        this.http.get(Conf.API_URL + '/blog-images/?things_to_do__slug=' + this.slug).subscribe(
            data => {
                this.blog_images = data['results'];

                var this_m = this;

                $.each(this.blog_images, function (index, value) {
                    this_m.galleryImages.push({
                        small: value.image,
                        medium: value.image,
                        big: value.image
                    })

                });
            },
            error => {
                console.log(error.error)
            }
        );
    }


}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/be-inspired/be-inspired.component.ts